import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postHomeFormFourStart,
  postHomeFormFourSuccess,
  postHomeTwoDataSuccess,
  postHomeFormFourFailure,
} from "../reducers/postHomeFormFourReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const postHomeFormFour = createAsyncThunk(
  "postHomeFormFour",
  async ({ values }, thunkAPI) => {
    try {
      thunkAPI.dispatch(postHomeFormFourStart());
      const token = Cookies.get("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/Home/SaveHomeThirdPage`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(postHomeFormFourSuccess(responseData?.data?.result));
      thunkAPI.dispatch(postHomeTwoDataSuccess(values));
      console.log(
        responseData?.data?.result,
        "<=========responseData?.data?.result"
      );
      return responseData;
    } catch (error) {
      thunkAPI.dispatch(postHomeFormFourFailure(error.response.data.Message));

      if (error.response.data.Message) {
        thunkAPI.dispatch(postHomeFormFourFailure(error.response.data.Message));
      } else {
        thunkAPI.dispatch(postHomeFormFourFailure(error.response.data.status));
      }
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
